var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { Subject } from "rxjs/Subject";
export var ImageService = (function () {
    function ImageService() {
        this.imagesUpdatedSource = new Subject();
        this.imageSelectedIndexUpdatedSource = new Subject();
        this.showImageViewerSource = new Subject();
        this.imagesUpdated$ = this.imagesUpdatedSource.asObservable();
        this.imageSelectedIndexUpdated$ = this.imageSelectedIndexUpdatedSource.asObservable();
        this.showImageViewerChanged$ = this.showImageViewerSource.asObservable();
    }
    ImageService.prototype.updateImages = function (images) {
        this.imagesUpdatedSource.next(images);
    };
    ImageService.prototype.updateSelectedImageIndex = function (newIndex) {
        this.imageSelectedIndexUpdatedSource.next(newIndex);
    };
    ImageService.prototype.showImageViewer = function (show) {
        this.showImageViewerSource.next(show);
    };
    ImageService = __decorate([
        Injectable(), 
        __metadata('design:paramtypes', [])
    ], ImageService);
    return ImageService;
}());
//# sourceMappingURL=c:/dev/ng2imggallery/src/app/services/image.service.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-image-gallery/app/services/image.service.js
// module id = 257
// module chunks = 3